export function getFontObj(fontsForLoading, fonts, colors, fontType) {
  return {
    family: fonts?.[fontType]?.font,
    link: fontsForLoading?.find(item => item?.fontName === fonts?.[fontType]?.font)?.fontUrl,
    size: fonts?.[fontType]?.fontSize,
    color: colors?.[fonts?.[fontType]?.colorVariant],
    weight: fonts?.[fontType]?.fontWeight,
  };
}
